import { FiCalendar, FiClock, FiTag, FiX } from 'react-icons/fi';
import { RESOLVE_PORTFOLIO_MEDIA_URL } from '../../../_Shared/resolveMediaUrl';

export const BlogArticleModal = ({ post, onClose }) => {
    const paragraphs = String(post.content || post.excerpt || '')
        .split(/\n\s*\n/)
        .map((item) => item.trim())
        .filter(Boolean);

    return (
        <div className="PB__modal_backdrop" onMouseDown={(event) => event.currentTarget === event.target && onClose()} role="presentation">
            <article className="PB__article_modal" role="dialog" aria-modal="true" aria-label={post.title}>
                <button type="button" className="PB__modal_close" onClick={onClose} aria-label="Cerrar"><FiX /></button>
                <div className="PB__article_scroll">
                    <div className="PB__article_cover">
                        {post.image ? <img src={RESOLVE_PORTFOLIO_MEDIA_URL(post.image)} alt={post.title} /> : <div />}
                        <span>{post.category || 'Articulo'}</span>
                    </div>
                    <div className="PB__article_content">
                        <div className="PB__blog_meta">
                            {post.published_at && <span><FiCalendar /> {post.published_at}</span>}
                            {post.read_time && <span><FiClock /> {post.read_time}</span>}
                        </div>
                        <h1>{post.title}</h1>
                        {post.excerpt && <p className="PB__article_lead">{post.excerpt}</p>}
                        <div className="PB__article_copy">{paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}</div>
                        {(post.tags || []).length > 0 && <div className="PB__article_tags"><FiTag /> {(post.tags || []).map((tag) => <span key={tag}>#{tag}</span>)}</div>}
                    </div>
                </div>
            </article>
        </div>
    );
};
